import { Route, Routes } from 'react-router-dom';

// basic routes
import VendorPaymentList from '../components/Vendor_Payments/VendorPaymentList';
import EditVendorPayment from '../components/Vendor_Payments/EditVendorPayment';
import ViewVendorPayment from '../components/Vendor_Payments/ViewVendorPayment';


const VendorPayments = () => {
  return (
    <Routes>
      <Route path="/" element={<VendorPaymentList />} />
      <Route path="/edit/:id" element={<EditVendorPayment />} />
      <Route path="/edit" element={<EditVendorPayment />} />
      <Route path="/view/:id" element={<ViewVendorPayment />} />
    </Routes>
  )
}

export default VendorPayments;